import Modal, { type ModalProps } from './modal';
import SideModal from './side-modal';
import StickyBlockModal from './sticky-block-modal';
import ModalLoader from './modal-loader';

export { SideModal, StickyBlockModal, ModalLoader, type ModalProps };

export default Modal;
